export class DialogModelDERetailerOutstandingInvoice {
    constructor(
      public outstandingData: any
    ) {}
  }